import { TranslateService } from '@ngx-translate/core';
import { UntypedFormBuilder } from '@angular/forms';
/*
  Created
    by: Pramod Kumar Reddy
    on: 26-Jul-2019 1:00 PM
    purpose: Change Password component

*/   

import { Component, OnInit, Inject, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormControl, Validators, } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ChangePasswordService } from '../../services/change-password/change-password.service';
import { NotificationService } from 'src/app/services/shared/notification/notification.service';
import { ResetPassword } from '../../classes/change-password/reset-password';
import { ChangePassword } from '../../classes/change-password/change-password';
import { getInvalidFields } from 'src/app/functions/shared-functions';
import { markFormGroupTouched } from 'src/app/controls/functions/shared-functions';
import { RoutesService } from 'src/app/services/shared/routes/routes.service';
import { SessionService } from 'src/app/services/session/session.service';


@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  providers: [
    ChangePasswordService
  ]
})
export class ChangePasswordComponent implements OnInit {

  change_new_password = new ChangePassword();
  reset_password = new ResetPassword();

  change_password = [];

  //variable for form
  change_password_form: UntypedFormGroup;

  ChangePasswordRef = ChangePassword;

  reset_password_form: UntypedFormGroup;
  ResetPasswordref = ResetPassword;
  route_subscription: Subscription;
  session_subscription: Subscription;
  new_hide: boolean;
  re_enter_hide: boolean;
  current_hide: boolean;
  @Input() flag;
  @Input() userId;
  password_min_length;
  init() {
    this.change_new_password.resetStaticVariables();
    this.change_new_password = new ChangePassword();
    this.change_new_password.setData();
    this.reset_password.resetStaticVariables();
    this.reset_password = new ResetPassword();
    this.reset_password.setData();
    this.change_password_form = this.fb.group({
      oldPassword: new UntypedFormControl('', Validators.required),
      newPassword: new UntypedFormControl('', [Validators.required]),
      reenter_password: new UntypedFormControl('', [Validators.required]),
      /* oldPassword: new FormControl('', [
        Validators.required,
        Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&]).{6,}')
       ]),
         newPassword: new FormControl('', [
           Validators.required,
           Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&]).{6,}')
          ]),
        reenter_password: new FormControl('',[
          Validators.required,
          Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&]).{6,}')
         ]),*/

    },
      {
        validators: this.checkPasswordMatching
      });
    this.reset_password_form = new UntypedFormGroup({
      newPassword: new UntypedFormControl('', [Validators.required]),
      reenter_password: new UntypedFormControl('', Validators.required),
      userId: new UntypedFormControl('')
    });
  }



  constructor(
    private change_password_service: ChangePasswordService,
    private routes_service: RoutesService,
    private router: Router,
    private activated_route: ActivatedRoute,
    private dialog: MatDialog,
    private session_svc: SessionService,
    public dialogRef: MatDialogRef<ChangePasswordComponent>,
    private fb: UntypedFormBuilder,
    private notification_svc: NotificationService,
    @Inject(MAT_DIALOG_DATA) public data,
    private translate: TranslateService

  ) { }

  checkPasswordMatching(group: UntypedFormGroup) {
    let pass = group.get('newPassword').value;
    let confirm_pass = group.get('reenter_password').value;
    if (pass != confirm_pass) {
      group.get('reenter_password').setErrors({
        notSame: true
      })
    }
    else {
      group.get('reenter_password').clearValidators();
    }
    // group.get('newPassword').updateValueAndValidity();
    return pass === confirm_pass ? null : { notSame: true };
  }
  ngOnInit() {
    this.init();
    this.session_subscription = this.session_svc.getSession().subscribe(res => {
      if (res && res['userId']) {
        this.change_password_form.patchValue({ userId: res['userId'] })
      }
    })
    // this.getChangedPassword();
    //subscribe to route changes. if the user selects another changepassword, listen to route changes and call the API only if userId is present in the URL and userId in the URL is not same as the one that is already present
  }

  getChangedPassword() {
    // this.change_password_service.getChangePassword(this.change_new_password).subscribe(res => {

    //   if (res['data']) {
    //     let pattern = "";
    //     if (res['data'].password_min_length && res['data'].password_max_length) {
    //       this.password_min_length = res['data'].password_min_length;
    //       if (this.change_password_form.get('newPassword')) {
    //         this.change_password_form.controls['newPassword'].setValidators([Validators.required, Validators.maxLength(res['data'].password_max_length)]);
    //       }/* else {
    //         this.change_password_form.controls['newPassword'].setValidators([Validators.maxLength(res['data'].password_max_length)]);
    //       }*/
    //       if (this.reset_password_form.get('newPassword')) {
    //         this.reset_password_form.controls['newPassword'].setValidators([Validators.required, Validators.maxLength(res['data'].password_max_length)]);
    //       }
    //       if (this.change_password_form.get('newPassword')) {
    //         this.change_password_form.controls['newPassword'].setValidators([Validators.required, Validators.minLength(res['data'].password_min_length)]);
    //       }
    //       if (this.reset_password_form.get('newPassword')) {
    //         this.reset_password_form.controls['newPassword'].setValidators([Validators.required, Validators.minLength(res['data'].password_min_length)]);
    //       }
    //       if (res['data'].alpha_numeric == 1) {
    //         this.change_password_form.controls['newPassword'].setValidators([Validators.required, Validators.pattern('^[a-zA-Z0-9-]*$')]);
    //         this.reset_password_form.controls['newPassword'].setValidators([Validators.required, Validators.pattern('^[a-zA-Z0-9-]*$')]);

    //       } else {
    //         pattern = '/[^a-zA-Z0-9-]*$+[A-Z]+[$@$!%?&]$/'
    //       }
    //       if (res['data'].upper_case == 1) {
    //         this.change_password_form.controls['newPassword'].setValidators([Validators.required, Validators.pattern('[A-Z]')]);
    //         this.reset_password_form.controls['newPassword'].setValidators([Validators.required, Validators.pattern('[A-Z]')]);
    //       }
    //       if (res['data'].special_characters == 1) {
    //         this.change_password_form.controls['newPassword'].setValidators([Validators.required, Validators.pattern('[$@$!%?&]')]);
    //         this.reset_password_form.controls['newPassword'].setValidators([Validators.required, Validators.pattern('[$@$!%?&]')]);
    //       }
    //     }
    //   }
    // })
  }


  save() {
    if (this.change_password_form.valid) {
      this.change_password_service.saveChangePassword(this.change_password_form.value).subscribe(res => {
        if (res['status'] == true) {
          this.notification_svc.success(res['message'], 'Cancel', 5000);
          this.dialogRef.close();
        }
        else {
          this.notification_svc.error(res['message'], 'Cancel', 5000);
        }
      })
    }
    else {
      getInvalidFields(this.change_password_form, this.translate, this.notification_svc, "FORGOT_PASSWORD.");
      markFormGroupTouched(this.change_password_form);
    }

  }
  Resetsave() {
    if (this.reset_password_form.valid) {
      this.change_password_service.resetChangePassword(this.reset_password_form.value).subscribe(res => {
        
        if (res['code'] == 500) {
          this.notification_svc.snackbar(res['message'], 'Cancel', 5000);
          this.dialogRef.close();
        }
        if (res['status'] == true) {
          this.notification_svc.snackbar(res['message'], 'Cancel', 5000);
          this.dialogRef.close();
        }
        else if (res['status'] == false && res['code'] == 200) {
          this.notification_svc.snackbar(res['message'], 'Cancel', 5000);
          //this.dialogRef.close();
        }
      }, err => {
        console.log(err);
      })
    }
    else {
      this.markerFormGroup(this.reset_password_form);
      this.notification_svc.snackbar('Please fill all the required fields', 'Cancel', 5000);
    }
  }
  cancel() {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    try {
      this.route_subscription.unsubscribe();
      this.session_subscription.unsubscribe();

    }
    catch (err) {

    }
  }
  // displayResetFormGroupErrors() {
  //   Object.keys(this.reset_password_form.controls).forEach(x => {
  //     this.reset_password_form.get(x).markAsTouched({ onlySelf: true });
  //   })
  // }
  markerFormGroup(formGroup: UntypedFormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      control.markAsDirty();
      if (control.controls) {
        this.markerFormGroup(control);
      }
    });
  }
}


















